import styled from "@emotion/styled";
import { Section } from "../../layout/section";

const StyledFaqs = styled.div`
	.h2 {
		text-align: center;
		margin-bottom: var(--x-small);
	}

	.faqs {
		display: flex;
		flex-direction: column;
		gap: var(--xx-small);
	}
`;

export interface FaqsProps {
	title: string;
	children: string | JSX.Element | JSX.Element[];
}

export const Faqs = ({ title, children }: FaqsProps) => (
  <Section>
    <StyledFaqs className="row">
	  <h2 className="h2">{title}</h2>
      <div className="faqs">{children}</div>
    </StyledFaqs>
  </Section>
);
